export function requiredRule(message = "Dieses Feld muss gefüllt sein"): (value: any) => boolean | string {
  return value => !!value || value === 0 || message;
}
